<template>
    <div style="display: flex; " v-if="site">
        <div>
            <c-site-title-row-comment
                :site = "site"
                style="padding-top: 4px; padding-right: 4px;"
            />
        </div>

        <div v-if="site.status">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class  = "site-status"
                        :class = "statusColorUnit"
                        v-bind = "attrs"
                        v-on   = "on"
                    ></div>
                </template>
                <span>{{ site.status.name }}</span>
            </v-tooltip>
        </div>


        <div>
            <v-tooltip
                bottom
                :content-class="statusColor"
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class  = " lm-status"
                        :class = "statusColor"
                        v-bind = "attrs"
                        v-on="on"
                    >
                        <div
                            :class="isInLim ? (site.liftmanagement && site.liftmanagement.contract && site.liftmanagement.contract.unit && site.liftmanagement.contract.unit.terminate ? 'black--text' : 'white--text') : 'primary--text'"
                        >
                            {{ contractType ? contractType : '---' }}
                        </div>
                    </div>
                </template>
                <div :class="isInLim ? (site.liftmanagement && site.liftmanagement.contract && site.liftmanagement.contract.unit && site.liftmanagement.contract.unit.terminate ? 'black--text' : 'white--text') : 'primary--text'">
                    <div style="font-weight: 600" v-if="site && site.liftmanagement">
                        {{ site.liftmanagement && site.liftmanagement.contract && site.liftmanagement.contract.type ? site.liftmanagement.contract.type.name : 'kein Vertrag' }}
                    </div>
                    <div>Laufzeit von {{ start }} bis {{ end }}</div>
                    <div class="white " v-if="site.liftmanagement && site.liftmanagement.contract && site.liftmanagement.contract.unit && site.liftmanagement.contract.unit.terminate">Vertrag wird beendet</div>
                </div>
            </v-tooltip>
        </div>

        <div v-if="tier">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        x-small
                        :color      = "tierBadgeColor"
                        :text-color = "tierBadgeTextColor"
                        class       = "mr-1"
                        v-bind      = "attrs"
                        v-on        = "on"
                    >
                        {{ tier }}
                    </v-chip>
                </template>
                <span>Vertragsstufe: {{ tier }}</span>
            </v-tooltip>
        </div>

        <div v-if="!hideType">
            <v-tooltip bottom >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        color="white"
                        size="25"
                        class="mr-1 site-icon"
                        v-bind="attrs"
                        v-on="on"
                        style="vertical-align: unset;"
                    >
                        {{ site.type.symbol }}
                    </v-icon>
                </template>
                <span>{{ site.type.name }}</span>
            </v-tooltip>
        </div>


        <v-tooltip bottom content-class="custom-tooltip white">
            <template v-slot:activator="{ on, attrs }">
                <div
                    v-bind = "attrs"
                    v-on   = "on"
                    class="v-flex"
                >
                    <div class="site-header" >
                        {{ $t('top.site.title', [ site.fabricNo, site.customer.name ]) }}
                    </div>
                    <div class="site-location">
                        {{ location }}
                    </div>
                </div>
            </template>
            <div class="lm-border primary-border-thick pa-2 black--text" style="width: 500px">
                <v-row dense>
                    <v-col class="no-frame col-3">
                        Buchungskreis
                    </v-col>
                    <v-col class="no-frame">
                        {{ site.ve }}
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col class="no-frame col-3">
                        Wirtschaftseinheit
                    </v-col>
                    <v-col class="no-frame">
                        {{ site.ve2 }}
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col class="no-frame col-3">
                        VE3
                    </v-col>
                    <v-col class="no-frame">
                        {{ site.ve3 }}
                    </v-col>
                </v-row>
            </div>
        </v-tooltip>
    </div>
</template>

<script>

import Site from "@/modules/msd/unit/service/Site";
import CSiteTitleRowComment from "@/modules/msd/unit/components/top/CSiteTitleRowComment";
import Core from "@/modules/core/service/Core";
import { isTierApplicable, tierColor, tierTextColor } from "@/modules/msd/company/contract/service/ContractTier";

export default {
    name: "CSiteTitle",
    props: {
        site: {
            required: false,
            type    : Object
        },

        hideType: {
            site: {
                required: false,
                type    : Boolean,
                default : function () {
                    return false;
                }
            },

        }
    },

    data: () => ({
    }),

    components: {
        CSiteTitleRowComment
    },

    computed: {
        contract () {
            if (!this.site.liftmanagement) {
                return true;
            }

            return this.site.liftmanagement.contract;
        },

        statusColor () {
            if (this.site.liftmanagement && this.site.liftmanagement.contract && this.site.liftmanagement.contract.unit && this.site.liftmanagement.contract.unit.terminate) {
                return "orange"
            }
            return Site.statusColor(this.site);
        },

        statusColorUnit () {
            return Site.statusColorUnit(this.site);
        },

        isInLim () {
            return Site.isInLftmanagement(this.site);
        },

        start () {
            if (!this.contract || !this.contract.unit) {
                return "---"
            }

            return Core.format.date.display(this.contract.unit.start)
        },

        end () {
            if (!this.contract || !this.contract.unit) {
                return "---"
            }

            return Core.format.date.display(this.contract.unit.end)
        },

        contractType () {
            if (!this.site.liftmanagement || !this.site.liftmanagement.contract || !this.site.liftmanagement.contract.type) {
                return null;
            }

            switch (this.site.liftmanagement.contract.type.id) {
                case 1:
                    return 'LIM';
                case 2:
                    return 'DLS';
            }

            return null;
        },

        tier () {
            if (!isTierApplicable(this.contract) || !this.contract.tier) {
                return null;
            }

            return this.contract.tier.name;
        },

        tierBadgeColor () {
            return tierColor(this.contract);
        },

        tierBadgeTextColor () {
            return tierTextColor(this.contract);
        },

        location () {
            return this.$t('top.site.location', [
                this.site.street ? this.site.street : '---',
                this.site.zip    ? this.site.zip    : '---',
                this.site.city   ? this.site.city   : '---'
            ]);
        }
    },

    methods: {
        format (value) {
            if (!value) {
                return "---"
            }

            return Core.format.date.display(value);
        },
    }


}
</script>

<style scoped>

.site-header {
    justify-content: left;
    color: white!important;
    font-size: 12pt!important;
    height: unset!important;
    padding-top: 4px;
    max-width: 330px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.site-location {
    font-size: 9pt;
    padding-left: 5px;
    padding-top: 8px;
    color: white;
}

.site-status {
    border-radius: 2px;
    margin-right: 5px;
    height: 20px!important;
    width: 20px!important;
    margin-top: 6px!important;
}

.site-status, .lm-status  {
    width: 20px;
    height: 20px;
    border-radius: 2px;
    cursor: pointer;
    margin-top: 6px;
}

.site-icon {
    width: 18px;
    height: 18px;
    margin-top: 6px;
}

.lm-status {
    background-color: white;
    margin-right: 5px;
    font-size: 7pt;
    text-align: center;
}

.lm-status div {
    padding-top: 4px
}

</style>

<style lang="scss" scoped>

.custom-tooltip {
    opacity: var(--v-tooltip-opacity, 1.0) !important;
    padding: 0!important;
}

</style>